import { assetActionList as asset } from 'views/AssetDetailsPage/actionsListData';
import { actionsListProject as project } from 'views/ProjectDetailsPage/actionsListData';
import { actionsListManageUsers as accountUsers } from 'views/AccountDetailsPage/components/AccountUsers/actionsListData';
import account from 'views/AccountDetailsPage/components/AccountDetailsTab/actionsListData';
import companyLocations from 'views/LocationDetails/views/CompanyDetailsPage/actionsListData';
import countryLocations from 'views/LocationDetails/views/CountryDetailsPage/actionsListData';
import locations from 'views/LocationDetails/views/LocationDetailsPage/actionsListData';
import contract from 'views/Contracts/actionsListData';
import costCenter from 'views/CostCenterDetailsPage/actionsListData';
import locationColumns from '../components/Locations/locationColumns';

export const actions = [
  ...account,
  ...accountUsers,
  ...locations,
  ...locationColumns,
  ...companyLocations,
  ...countryLocations,
  ...asset,
  ...contract,
  ...costCenter,
  ...project,
];
